module.exports = __webpack_public_path__ + "img/c59b1aaa5e98c6514f1f1df0acb631c0.png";